<template>
    <footer class="flex flex-col justify-center items-center bg-black text-white p-6">
        <div class="flex gap-4">
            <a href="https://www.imdb.com/name/nm10149117" aria-label="IMDb"><span class="i-fa6-brands-imdb h-10 w-10"/></a>
            <a href="https://www.instagram.com/zaramills.art" aria-label="Instagram"><span class="i-fa6-brands-instagram h-10 w-10"/></a>
        </div>
        <a class="email" href="mailto:zaramills@outlook.com">zaramills@outlook.com</a>
        <p class="my-4">Zara Mills © {{ year }}</p>
    </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const year = computed(() => new Date().getFullYear())
</script>

<style scoped>
.email {
    margin-top: 1rem;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.04em;
    line-height: 1.4;
}
</style>
